import React from "react";
import {Checkbox} from "primereact/checkbox";
import {ScrollPanel} from "primereact/scrollpanel";
import {primeIcons} from "../../../processes_documentation/static/static";

const IconSelector = ({selectedIcon, setSelectedIcon, selectedColor}) => (
	<div className="col-9">
		<div className="col-12 p-0 mb-1 text-secondary">Choose the card icon</div>
		<ScrollPanel style={{width: "100%", height: "115px"}}>
			{primeIcons.map(icon => (
				<div key={icon} className="p-0 ms-0 my-2 me-2 d-flex" style={{float: "left"}}>
					<Checkbox
						inputId={icon}
						className="d-none"
						name="icon"
						value={icon}
						checked={selectedIcon === icon}
						onChange={e => setSelectedIcon(e.value)}
					/>
					<label
						htmlFor={icon}
						className={
							selectedIcon === icon
								? `opacity-1 bg-${selectedColor} text-white d-flex justify-content-center align-items-center b-radius b-shadow ms-0 me-1`
								: "opacity-50 d-flex justify-content-center align-items-center b-radius ms-0 me-1"
						}
						style={{
							width: "30px",
							height: "30px",
							cursor: "pointer",
							border: "1px solid transparent",
							transition: "all 0.3s",
						}}>
						<i
							className={`pi ${icon} b-radius d-flex justify-content-center align-items-center`}
							style={{width: "30px", height: "30px"}}
						/>
					</label>
				</div>
			))}
		</ScrollPanel>
	</div>
);

export default IconSelector;
